__turbopack_context__.v({
  "countdown": "M_RBaG_countdown",
  "countdownWrapper": "M_RBaG_countdownWrapper",
  "urgencyWrapper": "M_RBaG_urgencyWrapper",
  "wrapper": "M_RBaG_wrapper",
});
